export function getBankVerifyErrorMessage(source) {
  const data = source?.response?.data ?? source;
  if (typeof data?.message === 'string' && data.message.trim()) {
    return data.message.trim();
  }
  if (typeof data?.error?.message === 'string' && data.error.message.trim()) {
    return data.error.message.trim();
  }
  if (typeof source?.message === 'string' && source.message.trim()) {
    return source.message.trim();
  }
  return 'Bank verification failed. Please upload documents for manual review.';
}

export function extractBankVerifyErrorData(source) {
  const data = source?.response?.data ?? source;
  if (data?.error && typeof data.error === 'object') return data.error;
  if (source?.error && typeof source.error === 'object') return source.error;
  return {};
}

export function isPanNameMismatchError(errData) {
  return errData?.code === 'PAN_BANK_NAME_MISMATCH' && Boolean(errData?.requires_cheque_upload);
}

export function buildBankManualUploadState(source, attemptedFields = {}) {
  const errData = extractBankVerifyErrorData(source);
  const serverMessage = getBankVerifyErrorMessage(source);
  const mismatchBank = errData.mismatch_bank || {};

  const accountNumber =
    mismatchBank.account_number
    || attemptedFields.accountNumber
    || '';
  const ifsc =
    mismatchBank.ifsc_code
    || mismatchBank.ifsc
    || attemptedFields.ifsc
    || '';
  const bankName =
    mismatchBank.bank_name
    || attemptedFields.bankName
    || '';
  const branchName =
    mismatchBank.branch_name
    || attemptedFields.branchName
    || '';

  return {
    ...errData,
    serverMessage,
    isPanNameMismatch: isPanNameMismatchError(errData),
    mismatch_bank: {
      ...mismatchBank,
      account_number: accountNumber,
      ifsc_code: ifsc,
      bank_name: bankName,
      branch_name: branchName,
    },
    prefill: {
      accountNumber,
      ifsc,
      bankName,
      branchName,
    },
  };
}

export function getProfileAttemptedBankFields(bankForm, bankIfscDetails) {
  const values = bankForm?.getFieldsValue?.() || {};
  return {
    accountNumber: String(values.account_number || '').trim(),
    ifsc: String(values.ifsc_code || '').trim().toUpperCase(),
    bankName: bankIfscDetails?.bank_name || '',
    branchName: bankIfscDetails?.branch_name || '',
  };
}

export function applyProfileBankManualUpload(manualUpload, setters) {
  const { prefill } = manualUpload;
  setters.bankForm?.setFieldsValue?.({
    account_number: prefill.accountNumber || '',
    ifsc_code: prefill.ifsc || '',
  });
  if (prefill.bankName || prefill.branchName) {
    setters.setBankIfscDetails?.({
      bank_name: prefill.bankName || '',
      branch_name: prefill.branchName || '',
      address: '',
    });
  }
  setters.setManualUploadData(manualUpload);
  if (setters.setBankIfscError) setters.setBankIfscError('');
}

export function resetProfileBankAddForm({
  bankForm,
  setBankIfscDetails,
  setBankIfscError,
  setManualUploadData,
  setIsBankFormOpen,
}) {
  bankForm?.resetFields?.();
  setBankIfscDetails?.(null);
  setBankIfscError?.('');
  setManualUploadData?.(null);
  setIsBankFormOpen?.(false);
}

export function applyBankManualUploadState(manualUpload, setters) {
  const {
    setAccountNumber,
    setIfsc,
    setBankName,
    setBranchName,
    setBankMode,
    setMismatchData,
    setErrors,
  } = setters;
  const { prefill } = manualUpload;

  setAccountNumber(prefill.accountNumber || '');
  setIfsc(prefill.ifsc || '');
  if (prefill.bankName) setBankName(prefill.bankName);
  if (setBranchName && prefill.branchName) setBranchName(prefill.branchName);
  setBankMode('manual');
  setMismatchData(manualUpload);
  setErrors({});
}
